import React, { useEffect, useRef, useState } from 'react'
import '../assets/login.css'
import { KebabIcon } from '../assets/KebabIcon'
import { useDownloaderHook } from '@/Shared/ui/downloader'
import { t } from 'i18next'
import { OreButton } from '@edenredespana/oreneta'
import { navigationTranslation } from '@/Shared/ui/navigation/navigationTranslation'
import { LegalDocumentType } from '@/Shared/domain'
import { LegalDocumentOptions } from '@/Account/domain/navbarModel'

export const KebabMenu: React.FC = () => {
  const { downloadPublicDocument } = useDownloaderHook()
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const options: LegalDocumentOptions[] = [
    {
      label: t(navigationTranslation.header.user.usageConditions),
      value: t(navigationTranslation.header.user.usageConditionsFileName),
      documentId: LegalDocumentType.useWebConditions
    },
    {
      label: t(navigationTranslation.header.user.legal),
      value: t(navigationTranslation.header.user.legalFileName),
      documentId: LegalDocumentType.legalAdvice
    },
    {
      label: t(navigationTranslation.header.user.cookiesPolicy),
      value: t(navigationTranslation.header.user.cookiesPolicyFileName),
      documentId: LegalDocumentType.cookiesPolicies
    },
    {
      label: t(navigationTranslation.header.user.privacyPolicy),
      value: t(navigationTranslation.header.user.privacyPolicyFileName),
      documentId: LegalDocumentType.privacyPolicies
    },
  ]

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (option: LegalDocumentOptions) => {
    downloadPublicDocument(option.documentId, option.value)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])


  return (
    <>
      <OreButton onClick={handleToggle} category="tertiary">
        <KebabIcon />
      </OreButton>
      {isOpen && (
        <div ref={dropdownRef} className="dropdown-list">
          {options.map((option, index) => (
            <div key={index} className="list-item" onClick={() => handleSelect(option)}>
              {option.label}
            </div>
          ))}
        </div>
      )}
    </>
  )
}
